// extracted by mini-css-extract-plugin
export default {"container":"Wp-z","heading":"Xp-z","text":"Yp-z","info":"Zp-z","link":"_p-z","fullMaxWidth":"aq-z"};